"use client";

import { useState } from "react";
import { Check, Link2, Share2 } from "lucide-react";
import { LinkedinIcon, FacebookIcon, XIcon, WhatsappIcon } from "@/components/ui/social-icons";

export function ShareButtons({ url, title }: { url: string; title: string }) {
  const [copied, setCopied] = useState(false);
  const eUrl = encodeURIComponent(url);
  const eTitle = encodeURIComponent(title);

  const links = [
    { label: "WhatsApp", icon: WhatsappIcon, href: `https://wa.me/?text=${eTitle}%20${eUrl}`, cls: "hover:bg-[#25D366] hover:text-white hover:border-[#25D366]" },
    { label: "LinkedIn", icon: LinkedinIcon, href: `https://www.linkedin.com/sharing/share-offsite/?url=${eUrl}`, cls: "hover:bg-[#0A66C2] hover:text-white hover:border-[#0A66C2]" },
    { label: "Facebook", icon: FacebookIcon, href: `https://www.facebook.com/sharer/sharer.php?u=${eUrl}`, cls: "hover:bg-[#1877F2] hover:text-white hover:border-[#1877F2]" },
    { label: "X", icon: XIcon, href: `https://twitter.com/intent/tweet?url=${eUrl}&text=${eTitle}`, cls: "hover:bg-ink hover:text-white hover:border-ink" },
  ];

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      /* clipboard unavailable */
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="mr-1 inline-flex items-center gap-1.5 text-sm font-medium text-ink-muted">
        <Share2 className="h-4 w-4" /> Share
      </span>
      {links.map((l) => (
        <a
          key={l.label}
          href={l.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Share on ${l.label}`}
          className={`inline-flex h-9 w-9 items-center justify-center rounded-full border border-line bg-white text-ink-soft transition-colors ${l.cls}`}
        >
          <l.icon className="h-4 w-4" />
        </a>
      ))}
      <button
        onClick={copy}
        aria-label="Copy link"
        className="inline-flex h-9 items-center gap-1.5 rounded-full border border-line bg-white px-3 text-sm text-ink-soft transition-colors hover:border-brand-500/50 hover:text-brand-700"
      >
        {copied ? <Check className="h-4 w-4 text-brand-600" /> : <Link2 className="h-4 w-4" />}
        {copied ? "Copied" : "Copy link"}
      </button>
    </div>
  );
}
